import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-md-5 mb-lg-0" }
const _hoisted_2 = { class: "d-none d-lg-flex d-flex align-items-center text-dark fw-bolder fs-3 my-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-flex h-20px border-gray-200 border-start mx-4" }, null, -1)
const _hoisted_4 = { class: "d-none d-md-flex me-auto" }
const _hoisted_5 = { class: "btn-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
const _hoisted_8 = { class: "d-none d-md-flex py-1" }
const _hoisted_9 = { class: "btn-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-flex h-20px border-gray-200 border-start mt-2 mx-4" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-filter fs-8" }, null, -1)
const _hoisted_12 = { class: "menu menu-sub menu-sub-dropdown w-250px w-md-300px show" }
const _hoisted_13 = { class: "px-7 py-5" }
const _hoisted_14 = { class: "mb-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark mb-5" }, "Filter by Call Type", -1)
const _hoisted_16 = ["value", "id"]
const _hoisted_17 = ["for"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-8" }, null, -1)
const _hoisted_19 = { class: "mb-5" }
const _hoisted_20 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-muted" }, " Show Conflicts ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.activeStart), 1),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          onClick: _ctx.previous,
          type: "secondary",
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          onClick: _ctx.next,
          type: "secondary",
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_Button, {
        onClick: _ctx.today,
        type: "",
        class: "btn-sm mx-2 btn-outline btn-outline-secondary text-white"
      }, {
        default: _withCtx(() => [
          _createTextVNode("jump to today")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeView('dayGridMonth'))),
          type: _ctx.currentViewType === 'dayGridMonth' ? 'primary' : 'secondary',
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode("month ")
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_Button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeView('timeGridWeek'))),
          type: _ctx.currentViewType === 'timeGridWeek' ? 'primary' : 'secondary',
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode("week ")
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_Button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeView('timeGridDay'))),
          type: _ctx.currentViewType === 'timeGridDay' ? 'primary' : 'secondary',
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode("day ")
          ]),
          _: 1
        }, 8, ["type"])
      ]),
      _hoisted_10,
      _createElementVNode("div", null, [
        _createVNode(_component_Popper, null, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableCallTypes, (callType) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-check form-check-custom form-check-solid mb-5",
                      key: callType.id
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.callTypes) = $event)),
                        value: callType.id,
                        id: callType.id,
                        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.filtersChanged && _ctx.filtersChanged(...args)))
                      }, null, 40, _hoisted_16), [
                        [_vModelCheckbox, _ctx.filters.callTypes]
                      ]),
                      _createElementVNode("label", {
                        class: "form-check-label flex-grow-1 fw-bold text-gray-700 fs-6",
                        for: callType.id
                      }, _toDisplayString(callType.name), 9, _hoisted_17),
                      _createElementVNode("span", {
                        class: _normalizeClass(`badge badge-sm badge-circle badge-${_ctx.getCallTypeColor(callType.color)} me-4`)
                      }, null, 2)
                    ]))
                  }), 128))
                ]),
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.showConflicts) = $event)),
                      id: "showConflicts",
                      onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.conflictsFilterChanged && _ctx.conflictsFilterChanged(...args))),
                      checked: "checked"
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.filters.showConflicts]
                    ]),
                    _hoisted_21
                  ])
                ])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "secondary",
              class: "btn-sm me-4"
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createTextVNode(" Filter")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          onClick: _ctx.invokeAddConflict,
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Add Conflict")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ], 64))
}